import theme from '../../theme/'

const styles = {
  drawerContent: {
    padding: theme => theme.spacing(2.75, 2),
    height: '100vh',
    [theme.breakpoints.up('sm')]: {
      height: 'auto',
      width: 640,
      padding: 8,
    },
  },
  closeButtonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    mb: 4,
  },
}

export default styles
